import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Breadcrumb = () => {
  const location = useLocation();
  
  // Define page titles for different routes
  const pageTitles = {
    '/ai-advisor': 'Career Advisor AI',
    '/friends': 'Find Friends',
    '/image-generator': 'Creator Zone',
    '/test-prep': 'GRE & GMAT Prep',
    '/profile': 'My Profile',
    '/career-ambition': 'Career Ambition',
    '/admin': 'Admin Dashboard',
    '/admin-offers': 'Admin Offers',
    '/admin/promos': 'Promo Codes',
    '/job-board': 'Job Board',
    '/employer-dashboard': 'Employer Dashboard',
    '/post-job': 'Post a Job',
    '/courses': 'Browse Courses',
    '/my-learning': 'My Learning',
    '/calendar': 'Class Calendar',
    '/lms-admin': 'LMS Admin',
    '/payment': 'Payment',
    '/payment-success': 'Payment Successful',
    '/buy-credits': 'Buy AI Credits',
    '/checkout': 'Checkout',
    '/dashboard': 'Dashboard',
    '/learn-research': 'Learn & Research',
    '/creator-ai/social-creatives': 'Social Media Creatives',
    '/creator-ai/bulk-create': 'Bulk Create',
    '/creator-ai/reels-avatar': 'Reels with Avatars',
    '/creator-ai/text-to-image': 'Text to Image',
    '/creator-ai/avatar-video': 'Avatar Video',
    '/creator-ai/avatar-motion': 'Avatar Motion',
    '/creator-ai/digital-twin': 'Digital Twin',
    '/creator-ai/heygen-hub': 'HeyGen Hub',
    '/creator-ai/photo-avatar': 'Photo Avatar',
    '/creator-ai/video-agent': 'Video Agent',
    '/creator-ai/video-translate': 'Video Translate',
    '/terms-and-conditions': 'Terms & Conditions',
    '/contact-us': 'Contact Us',
    '/pricing': 'Pricing Plans',
    '/privacy': 'Privacy Policy',
    '/about': 'About Us',
    '/free-trial-exams': 'Free Trial Exams',
    '/exam-bank': 'Exam Bank',
    '/engineering-exam-bank': 'Engineering Exams',
    '/pharmacy-exam-bank': 'Pharmacy Exams',
    '/dentist-exam-bank': 'Dentist Exams',
    '/global-exam-bank': 'Global Exams',
    '/samhara-ai': 'Samhara AI — Deepfake Detector',
    '/student-offers': 'Student Offers',
    '/delete-account': 'Delete Account',
    '/chat': 'AI Chat',
    '/verify-certificate': 'Verify Certificate',
    '/mermaid-demo': 'Diagram Demo',
    '/test-prep-admin': 'Test Prep Admin',
  };
  
  // Don't show breadcrumbs on home page
  if (location.pathname === '/') {
    document.title = 'Nerd Nation — Your AI Academic Companion';
    return null;
  }

  // Handle dynamic routes
  let currentPage = pageTitles[location.pathname];
  if (!currentPage) {
    const p = location.pathname;
    if (p.startsWith('/jobs/'))                      currentPage = 'Job Details';
    else if (p.startsWith('/courses/'))              currentPage = 'Course Details';
    else if (p.startsWith('/category/'))             currentPage = 'Course Category';
    else if (p.startsWith('/lms-admin/'))            currentPage = 'LMS Admin';
    else if (p.startsWith('/lms/payment-success'))   currentPage = 'Payment Successful';
    else if (p.startsWith('/lms/payment/'))          currentPage = 'Enrolment Payment';
    else if (p.startsWith('/lms/'))                  currentPage = 'Learning';
    else if (p.startsWith('/checkout/'))             currentPage = 'Checkout';
    else if (p.startsWith('/exam-bank/'))            currentPage = 'Exam';
    else if (p.startsWith('/exam-preparation/'))     currentPage = 'Exam Preparation';
    else if (p.startsWith('/test-taking/'))          currentPage = 'Test';
    else if (p.startsWith('/certificates/'))         currentPage = 'Certificate';
    else if (p.startsWith('/verify-certificate/'))   currentPage = 'Verify Certificate';
    else if (p.startsWith('/shared-video/'))         currentPage = 'Shared Video';
    else if (p.startsWith('/promo/'))                currentPage = 'Promo Offer';
    else                                             currentPage = 'Nerd Nation';
  }

  // Set browser tab title
  document.title = `${currentPage} — Nerd Nation`;
  
  return (
    <nav className="bg-gray-50 border-b border-gray-200 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center space-x-2 py-3 text-sm">
          <Link 
            to="/" 
            className="flex items-center text-gray-500 hover:text-gray-700 transition-colors"
            data-testid="breadcrumb-home"
          >
            <Home className="h-4 w-4 mr-1" />
            Home
          </Link>
          
          <ChevronRight className="h-4 w-4 text-gray-400" />
          
          <span className="text-gray-900 font-medium" data-testid="breadcrumb-current">
            {currentPage}
          </span>
        </div>
      </div>
    </nav>
  );
};

export default Breadcrumb;